import { useState, useCallback} from "react"
import Breadcrumbs from "../../../coreComponents/breadcrumbs"
import CommonCardHeader from "../../../coreComponents/CommonCardHeader"
import ApiService from "../../../services/apiService"
import Table from "../../table/Table"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { Card, Modal, ModalBody, ModalHeader, ModalFooter,Button} from "reactstrap"
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { usePagination } from "../../../hooks/usePagination"
import FilterIcon from "../../svg/FilterIcon"
 import LeftIcon from "../../svg/LeftButton"
 import RightIcon from "../../svg/RightIcon"
import { Filter } from "react-feather"
const ProjectSettings = () => {
    const role = useAppSelector((state) => state.role.role);
   
    const[isDeleteModalOpen,setIsDeleteModalOpen] = useState(false)
    const[selectedId,setSelectedId] = useState("")
   
    const navigate = useNavigate();
    /*useEffect(() => {

        const fetchProjects = async () => {
            try {
                const response = await ApiService.axiosApi(`/projectsettings/getallproject`, {
                    method: 'GET'
                })
                if (response.success) {
                    setProjectData(response.data)
                } else {
                    console.log(response.message || response.status || "unable to get projects")
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchProjects();
    }, [refresh])*/

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy
      } = usePagination({
        endpoint: `/projectsettings/getallproject`,
        filterOn:'FieldName',
        enabled:true
      })
      const totalPages = Math.ceil(totalCount / pageSize);
    
      const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
      }, [setPageNumber, totalPages])
    
    
    
      const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
      }, [setPageNumber, totalPages])

    const handleDelete = (id:string) => {
        setIsDeleteModalOpen(true)
        setSelectedId(id);
    }

    const deleteProject = async (selectedId: string) => {
        try {
            const response = await ApiService.axiosApi(`/projectsettings/deleteproject${selectedId}`, {
                method: 'DELETE'
            })
            if (response.success) {
                toast.success("Project delete successfully")
                setIsDeleteModalOpen(false)
                setRefresh(prev => !prev)
            } else {
                console.log(response.message || response.status || "unable to delete project")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleUpdate = (id: string) => {
        navigate(`/project-update/${id}`)
    }



    return (
        <>
            <Breadcrumbs mainTitle="Projects" parent="Settings" />
            
                <Card>
                <CommonCardHeader title="Projects Settings" headClass={"pb-3"}/>
                <div className="d-flex justify-content-between">
                    <div style={{marginLeft:'10px'}}>
                       <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        <button className="filter-button mx-2" style={{height:'30px'}} onClick={()=>setSortBy('projectName')}>
                         <Filter/>
                      </button>
                    </div>
                {role === "Administrator" && (
                <div className="d-flex justify-content-end">
                    <Button onClick={() => navigate(`/project-add`)} color="primary" className="mb-2 mx-2">Add Projects</Button>
                </div>
                )}
                </div>
                    <Table
                        data={data}
                        columns={[
                            { header: "Project Name", accessor: "projectName" },
                            { header: "Number Of Doors", accessor: "no_Of_Door" },
                            {header:"Number Of WaterMeter", accessor:"no_Of_WaterMeter"},
                            {header:"Number Of PressureValve", accessor:"no_Of_PressureValve"},
                             {header:"Total Valves",accessor:"totalValves"}
                        ]}
                        buttons={[
                            { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger", }
                        ]}
                    />
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
            <p style={{ marginRight: '10px', marginTop: '8px' }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
                </Card>

                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>

                    <ModalHeader>Delete User</ModalHeader>
                    <ModalBody>Are you sure you want to delete this user?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => deleteProject(selectedId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>

                </Modal>

            
        </>

    )
}
export default ProjectSettings;